/* CSS */
import "./src/main.scss"
import "./src/scss/custom-aos.scss" /* import seperately to protect against purge css */

/* Intersection Observer Polyfill */
export const onClientEntry = async () => {
  if (typeof IntersectionObserver === "undefined") {
    await import("intersection-observer")
  }

  if (!window.plausible) {
    window.plausible = function () {
      ;(window.plausible.q = window.plausible.q || []).push(arguments)
    }
  }

  const script = document.createElement("script")
  script.async = true
  script.defer = true
  script.src = "https://plausible.io/js/pa-nEDx8nnKz6x6MOzzmhXGo.js"

  document.head.appendChild(script)
}
